@if (type === MediaType.Audio) {
	<audio hidden #audioPlayer (timeupdate)="timeUpdateAudio($event)"></audio>
}

<sim-basic-material-dialog
	(closeClicked)="
		close({
			uploadedFiles: uploadedFiles,
			action: 'ok',
		})
	"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.UPLOAD_MEDIA_DIALOG_TITLE | translate: {type: (mediaTypeKey | translate)}"
	[headerIcon]="{fontIcon: 'fa-upload', fontSet: 'fad'}"
	class="normalDuotoneHeaderIcon"
	[overflowHandledByChild]="true"
>
	<ng-container dialogContent>
		<input
			type="file"
			[accept]="acceptedFileTypesText"
			multiple
			id="upload"
			#uploadInput
			hidden="hidden"
			(change)="handleFileInput($event)"
		/>

		<input
			type="file"
			multiple
			id="folderUpload"
			#folderUploadInput
			hidden="hidden"
			(change)="handleFolderInput($event)"
			webkitdirectory
		/>

		@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
			<div class="previewText">
				{{ T.ASSESSMENT_EDIT_PREVIEW | translate }}
			</div>
		}

		@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
			<div class="previewFiles">
				<div class="filePreviewList">
					@for (currentSelectedFile of currentSelectedFiles; track currentSelectedFile; let i = $index) {
						<div class="previewFile" [@anim]="'active'">
							<sim-media-card-list
								[previewMedia]="true"
								[previewMediaType]="type"
								[mediaName]="currentSelectedFile.name"
								(mediaNameChange)="currentSelectedFile.newName = $event"
								[active]="currentSelectedFile?.isPlaying"
								[progress]="currentSelectedFile?.progress"
								[currentSelectedFile]="currentSelectedFile"
								[showDeleteButton]="true"
								[previewMediaUrl]="currentSelectedFile.mediaUrl"
								(mediaClicked)="toggleMediaPlaying(currentSelectedFile, i)"
								(deleteButtonClicked)="deleteFromSelection(i)"
								[isUploading]="currentSelectedFile.isUploading"
								[uploadProgress]="currentSelectedFile.progressUploading"
							/>
						</div>
					}
				</div>
			</div>
		}

		<div class="uploadFilesFirst">
			<div class="uploadBtn">
				<button
					mat-raised-button
					[color]="currentSelectedFiles && currentSelectedFiles.length !== 0 ? 'warn' : 'accent'"
					(click)="chooseFiles()"
				>
					{{
						(currentSelectedFiles && currentSelectedFiles.length !== 0
							? T.UPLOAD_MEDIA_DIALOG_CLEAR_SELECTION
							: T.UPLOAD_MEDIA_DIALOG_CHOOSE_FILE
						) | translate
					}}
				</button>

				@if (!(currentSelectedFiles && currentSelectedFiles.length !== 0)) {
					<button
						mat-raised-button
						[color]="currentSelectedFiles && currentSelectedFiles.length !== 0 ? 'warn' : 'accent'"
						(click)="chooseFolders()"
					>
						{{
							(currentSelectedFiles && currentSelectedFiles.length !== 0
								? T.UPLOAD_MEDIA_DIALOG_CLEAR_SELECTION
								: T.UPLOAD_MEDIA_DIALOG_CHOOSE_FOLDERS
							) | translate
						}}
					</button>
				}
				<button
					class="uploadToSimStation"
					(click)="uploadFiles()"
					mat-raised-button
					color="accent"
					[hidden]="!currentSelectedFiles || currentSelectedFiles?.length === 0"
				>
					{{ T.UPLOAD_MEDIA_DIALOG_BUTTON | translate }}
				</button>
			</div>

			@if (afterViewInit && !currentSelectedFiles) {
				<div
					class="uploadHint"
					[@zoomInOnEnter]
					[@zoomOutOnLeave]
					[innerHTML]="(T.UPLOAD_MEDIA_DIALOG_HINTS | translate) + acceptedFileTypes"
				></div>
			}
		</div>
	</ng-container>
</sim-basic-material-dialog>
